module.exports = __webpack_public_path__ + "img/kommune-437.cbd4a613.svg";